<template>
    <!--<b-modal-->
    <!--    v-model="show_infos_modal"-->
    <!--    scroll="clip"-->
    <!--    has-modal-card-->
    <!--    trap-focus-->
    <!--    can-cancel-->
    <!--    :destroy-on-hide="false"-->
    <!--    aria-role="dialog"-->
    <!--    aria-label="Example Modal"-->
    <!--    aria-modal>-->
        <div class="card">
            <b-tabs v-model="tab" position="is-centered" multiline>
                <b-tab-item headerClass="tab-head" label="COOKIES" value="cookies"><CookiesModal></CookiesModal></b-tab-item>
                <b-tab-item headerClass="tab-head" label="CONDITIONS" value="conditions"><ConditionsModal></ConditionsModal></b-tab-item>
                <b-tab-item headerClass="tab-head" label="CONTACT" value="contact"><ContactModal></ContactModal></b-tab-item>
                <b-tab-item headerClass="tab-head" label="VIE PRIVÉE" value="privacy"><PrivacyModal></PrivacyModal></b-tab-item>
                <b-tab-item headerClass="tab-head" label="FAQ" value="faq"><FaqModal></FaqModal></b-tab-item>
            </b-tabs>
        </div>
    <!--</b-modal>-->
</template>

<script>
import {sync} from "vuex-pathify";

import CookiesModal from "./CookiesModal";
import ContactModal from "./ContactModal";
import ConditionsModal from "./ConditionsModal";
import PrivacyModal from "./PrivacyModal";
import FaqModal from "./FaqModal";
export default {
    components:{CookiesModal, ContactModal, ConditionsModal, PrivacyModal, FaqModal},
    props:{
        activeTab:String,
    },
    data(){
        return{
            tab: 0,
        }
    },
    created() {
        this.tab=this.activeTab;
        console.log(this.tab)
    }
}
</script>

<style scoped>

</style>
